export const GET_TAXES_SUCCESS = 'GET_TAXES_SUCCESS';
export const GET_TAXES_REQUESTED = 'GET_TAXES_REQUESTED';
export const DELETE_TAX_REQUESTED = 'DELETE_TAX_REQUESTED';
export const ADD_TAX_REQUESTED = 'ADD_TAX_REQUESTED';
export const UPDATE_TAX_REQUESTED = 'UPDATE_TAX_REQUESTED';
export const GET_TAXED_LOCATIONS_REQUESTED = 'GET_TAXES_LOCATIONS_REQUESTED';
export const GET_TAXED_LOCATIONS_SUCCESS = 'GET_TAXES_LOCATIONS_SUCCESS';
export const GET_TAXED_PRODUCTS_REQUESTED = 'GET_TAXES_PRODUCTS_REQUESTED';
export const GET_TAXED_PRODUCTS_SUCCESS = 'GET_TAXES_PRODUCTS_SUCCESS';
export const GET_TAXED_CATEGORIES_REQUESTED = 'GET_TAXES_CATEGORIES_REQUESTED';
export const GET_TAXED_CATEGORIES_SUCCESS = 'GET_TAXES_CATEGORIES_SUCCESS';
